import notie from 'notie';
import common from './common';

let stripe,
    checkoutForm,
    emailInput,
    amountInput,
    invoiceId,
    submitButton,
    paymentIntentId;

const pay = {
  init() {

    // If we want check discounts to be payments...
    // let addCheckDiscount = document.querySelector('[data-add-check-discount]');
    // if (addCheckDiscount) {
    //   addCheckDiscount.addEventListener('click', e => {
    //     e.preventDefault();
    //     let checkDiscount = document.querySelector('[data-check-discount]').innerText;
    //     document.querySelector('#manual-payment input[name=amount]').value = '-'+checkDiscount;
    //     document.querySelector('#manual-payment input[name=payment_type]').value = 'check discount';
    //     document.querySelector('#manual-payment input[name=email]').value = '';
    //   });
    // }

    // Button to show Manual Payment form
    let addManualPayment = document.querySelector('[data-add-manual-payment]');
    if (addManualPayment) {
      addManualPayment.addEventListener('click', e => {
        e.preventDefault();
        // Show manual payment form
        document.querySelector('.manual-payment-wrap').classList.remove('hidden');
        // Hide button
        e.target.classList.add('hidden');
        // Hide checkout form
        document.querySelector('#checkout').classList.add('hidden');
      });
    }

    // Truncate longer invoices and show button to expand
    let invoice = document.querySelector('table.invoice');
    let items = invoice.querySelectorAll('tbody tr');
    if (items.length > 5) {
      invoice.classList.add('truncated');
      let expandButton = document.createElement('button');
      expandButton.className = 'button expand-button color-hover';
      expandButton.textContent = `+ Show All Invoice Items (${items.length})`;
      document.querySelector('.invoice-wrap').appendChild(expandButton);
      expandButton.addEventListener('click', e => {
        invoice.classList.remove('truncated');
        expandButton.remove();
      });
      // Re-init hovers
      common.hovers();
    }

      // Handle payment form
    if (document.querySelector('#payment-dropin')) {

      // Init stripe with public key
      stripe = Stripe(stripePublicKey);

      amountInput = document.querySelector('#amount');
      emailInput = document.querySelector('#email');
      checkoutForm = document.querySelector('#checkout');
      submitButton = checkoutForm.querySelector('button.submit');
      invoiceId = document.querySelector('input[name="invoice_id"]').value;

      // Disable submit button to start
      submitButton.disabled = true;

        pay.getPaymentIntent();

        // When changing amount, update payment form
        amountInput.addEventListener('change', e => {
          if (amountInput.value !== '') {
            pay.updatePaymentIntent();
          }
        });

        // When changing email, update payment form
        emailInput.addEventListener('change', e => {
          if (amountInput.value !== '') {
            pay.updatePaymentIntent();
          }
        });

    }

  },

  updatePaymentIntent() {
    fetch('/inc/the-stripe-intent.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        action: 'update',
        payment_intent_id: paymentIntentId,
        amount: amountInput.value,
        invoice_id: invoiceId,
        email: emailInput.value
      })
    })
  },

  getPaymentIntent() {
    fetch('/inc/the-stripe-intent.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        action: 'create',
        amount: amountInput.value,
        invoice_id: invoiceId,
        email: emailInput.value
      })
    })
      .then(function(result) {
        return result.json();
      })
      .then(function(data) {

        // Set paymentIntentId for updating
        paymentIntentId = data.id;

        let elements = stripe.elements({
          fonts: [{
            cssSrc: 'https://fonts.googleapis.com/css?family=Inconsolata'
          }],
        });

        let style = {
          base: {
            color: '#333',
            fontFamily: 'Inconsolata, monospace',
            fontSize: '14px',
            '::placeholder': {
              color: '#333'
            }
          },
          invalid: {
            fontFamily: 'Inconsolata, monospace',
            color: '#BB4A44',
            iconColor: '#BB4A44'
          }
        };
        let card = elements.create('card', {
          style: style,
          hidePostalCode: true,
        });
        card.mount('#payment-dropin');

        card.on('change', function (event) {
          // Disable the Pay button if there are no card details in the Element
          submitButton.disabled = event.empty;
          if (event.error) {
            notie.alert({
              type: 'error',
              text: event.error.message
            });
          }
        });

        checkoutForm.addEventListener('submit', function(event) {
          event.preventDefault();
          // Complete payment when the submit button is clicked
          pay.submitPayment(stripe, card, data.clientSecret);
        });
      });
  },

  // Calls stripe.confirmCardPayment
  // If the card requires authentication Stripe shows a pop-up modal to
  // prompt the user to enter authentication details without leaving your page.
  submitPayment(stripe, card, clientSecret) {
    pay.loading(true);
    stripe
      .confirmCardPayment(clientSecret, {
        payment_method: {
          card: card
        }
      })
      .then(function(result) {
        if (result.error) {
          // Show error in alert
          pay.showError(result.error.message);
        } else {
          // Payment success
          pay.orderComplete(result.paymentIntent.id);
        }
      });
  },

  orderComplete(paymentIntentId) {
    pay.loading(false);
    notie.force({
      type: 'success',
      text: 'Success! Thanks for your payment.<br>You should receive an email receipt soon.',
      buttonText: 'OK',
      callback: () => location.reload()
    });
    checkout.remove();
  },

  showError(errorMsgText) {
    pay.loading(false);
    notie.force({
      type: 'error',
      text: errorMsgText,
      buttonText: 'OK'
    });
  },

  loading(isLoading) {
    if (isLoading) {
      checkoutForm.classList.add('working');
      submitButton.disabled = true;
    } else {
      checkoutForm.classList.remove('working');
      submitButton.disabled = false;
    }
  },

  finalize() {
    // JavaScript to be fired on the pay page, after the init JS
  },
};

export default pay
